import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    return (
        <header>
            <Link to="/" className="brand-link" aria-label="トップページへ">
                <img className="logo" src="/img/common/logo.svg" alt="RubyMagic" />
                <h1 className="logo-text garamond">RubyMagic</h1>
            </Link>
        </header>
    );
};

export default Header;